import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import api from '../utils/axiosConfig';
import { lockSession } from '../store/authSlice';
import { authStorage } from '../platform/storage';
import { watchNativeActivity } from '../platform/nativeActivity.mjs';
import { readTokenClaims } from '../platform/sessionTokens.mjs';

export default function NativeSessionActivity() {
    const dispatch = useDispatch();
    useEffect(() => {
        const controller = new AbortController();
        const stop = watchNativeActivity(document, async () => {
            let current;
            try {
                current = await authStorage.get('token');
            } catch (error) {
                // This read runs before Axios can route biometric locks to the login UI.
                if (!controller.signal.aborted && error?.code === 'BIOMETRIC_LOCKED') dispatch(lockSession());
                throw error;
            }
            if (controller.signal.aborted || !readTokenClaims(current)?.sid) return;
            const response = await api.post('/api/auth/activity', {}, { signal: controller.signal, sessionToken: current });
            if (controller.signal.aborted) return;
            const token = response.config.headers.Authorization?.replace(/^Bearer /, '');
            await authStorage.acceptActivity(token, response.data);
        });
        return () => { stop(); controller.abort(); };
    }, [dispatch]);
    return null;
}
